// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1AfiT","insightsList":"newBusinessInsightsMenu_insightsList__1XBhz","active":"newBusinessInsightsMenu_active__WcOqE"};